export const SELECT_COUNTRY = 'SELECT_COUNTRY';
export const REMOVE_COUNTRY = 'REMOVE_COUNTRY';
export const REMOVE_ALL_COUNTRIES = 'REMOVE_ALL_COUNTRIES';
export const ADD_SELECTED_COUNTRIES = 'ADD_SELECTED_COUNTRIES';

export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_FAILURE = 'GET_COUNTRIES_FAILURE';
